var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('Header',{staticClass:"page__header"}),_vm._t("default"),_c('Footer',{staticClass:"page__footer"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }